import { formatTauxClick } from './kkpPlanningFormat';

const emptyMoyenne = () => ({
  affichage: null,
  pub_cliquees: null,
  taux_click: null,
  semaines_avec_donnees: 0,
});

/** Affichage prêt à compter : nombre strictement positif (0 / vide / null = pas encore sync). */
function parsePositiveAffichage(value) {
  if (value == null || value === '') return null;
  const n = Number(String(value).replace(/\s/g, '').replace(',', '.'));
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n);
}

function parseClickPart(value) {
  if (value == null || value === '') return null;
  const n = Number(String(value).replace(/\s/g, '').replace(',', '.'));
  if (!Number.isFinite(n)) return null;
  return Math.max(0, Math.round(n));
}

/**
 * Clics d’une ligne, alignés sur le tableau : (click_desktop ?? pub_cliquees) + click_mobile.
 * Un 0 mobile ne doit pas masquer pub_cliquees.
 */
function rowClicks(row) {
  const desktopOrPub = parseClickPart(row?.click_desktop ?? row?.pub_cliquees);
  const mobile = parseClickPart(row?.click_mobile);
  return (desktopOrPub ?? 0) + (mobile ?? 0);
}

/**
 * Moyenne des lignes visibles qui ont un affichage > 0 (placeholders exclus).
 * Affichages = cumul / n, clics = cumul / n, taux = moyenne clics / moyenne affichages.
 *
 * @param {Array<Record<string, unknown>>} rows
 * @returns {{
 *   affichage: number|null,
 *   pub_cliquees: number|null,
 *   taux_click: string|null,
 *   semaines_avec_donnees: number,
 * }}
 */
export function computeWebMoyenneHebdo(rows) {
  let sumAffichage = 0;
  let sumClics = 0;
  let n = 0;

  for (const row of rows ?? []) {
    if (row?.is_placeholder) continue;

    const affichage = parsePositiveAffichage(row?.affichage);
    if (affichage == null) continue;

    n += 1;
    sumAffichage += affichage;
    sumClics += rowClicks(row);
  }

  if (n === 0) {
    return emptyMoyenne();
  }

  const moyenneAffichage = Math.round(sumAffichage / n);
  const moyenneClics = Math.round(sumClics / n);

  return {
    affichage: moyenneAffichage,
    pub_cliquees: moyenneClics,
    taux_click: moyenneAffichage > 0
      ? formatTauxClick(`${(moyenneClics / moyenneAffichage) * 100} %`)
      : null,
    semaines_avec_donnees: n,
  };
}
